import { createAction } from 'redux-starter-kit';

export const SET_TOKEN = '/auth/SET_TOKEN';

const setToken = createAction(SET_TOKEN);

export const authActions = {
  setToken
};
